import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import globalAssetCenterReducer from '../reducers/globalAssetCenterReducer';

const configureStore = (railsProps) => (
  createStore(globalAssetCenterReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
